/* eslint-disable import/prefer-default-export */

export const parseDirectionsUrl  = (url) => {
    // https://www.google.com/maps/dir/
    // 59.8909974,10.5213962/Sandvika+%5Btog%5D/@59.8925769,10.5239806,19z/
    // data=!4m9!4m8!1m0!1m5!1m1!1s0x46411367834b3f8d:0x60d1bbe3318d8394!2m2!1d10.524921!2d59.892628!3e2
    const rawArray = url.split('/');

    if( !_.has(rawArray,'[5]') || _.get(rawArray,'[5]','').split(',').length !== 2) return null
    let origin = _.get(rawArray,'[5]','').split(',');
    origin = { lat: parseFloat(origin[0]), lng: parseFloat(origin[1]) };

    let dest = _.get(rawArray,'[7]','').replace('@','').split(',')
    const zoom = _.get(dest,'[2]','');

    dest = { lat: parseFloat(dest[0]), lng: parseFloat(dest[1]) };

    return origin && dest && zoom ? {origin, destination: dest, zoom} : null;
};

export const getDirectionsUrl = ({lat,lng}, origin='Current+Location') => `https://www.google.com/maps/dir/${origin}/${lat},${lng}`
